module.exports = __webpack_public_path__ + "static/media/Rataplan-min.9cbf490f.png";